import React from 'react'
import {Page, View, Document} from "@react-pdf/renderer";

import { baseStyles} from "../../styles";
import {FeeBreakdownPDF} from "../../components/FeeBreakdownPDF";
import {VehicleInfoPDF} from "../../components/VehicleInfoPDF";
import {PurchaseCustomerPaymentInformationPDF} from "./PurchaseCustomerPaymentInformationPDF";
import {PurchaseCustomerPriceBreakdownPDF} from "./PurchaseCustomerPriceBreakdownPDF";
import {HeaderPDF} from "../../components/HeaderPDF";
import {BasePDF} from "../../BasePDF";
import {FooterPDF} from "../../components/FooterPDF";

export const PurchaseCustomerDisclosurePDF = ( {companyName, customerName, customerAddress, dealState, ...props } ) => {
    return (
        <BasePDF dealState={dealState} {...props}>
            <Document>
                <Page size="A4" style={baseStyles.page} wrap={false}>
                    <HeaderPDF
                        pdfName={'Customer Worksheet'}
                        companyName={companyName}
                        customerName={customerName}
                        customerAddress={customerAddress}
                    />

                    <VehicleInfoPDF/>

                    <View style={{...baseStyles.tablesLayout}}>
                        <View style={{...baseStyles.flexColumn, ...baseStyles.leftColumn}}>
                            <PurchaseCustomerPaymentInformationPDF/>
                            <FeeBreakdownPDF/>
                        </View>

                        <View style={{...baseStyles.flexColumn, ...baseStyles.rightColumn}}>
                            <PurchaseCustomerPriceBreakdownPDF/>
                        </View>
                    </View>
                    <FooterPDF/>
                </Page>
            </Document>
        </BasePDF>
    )
}